/**
 * سطوح دسترسی برگشتی از API (رشته‌ای)
 * added  — فقط رکوردهایی که کاربر اضافه کرده (added_by)
 * owned  — فقط رکوردهایی که مالک آن‌هاست (user_id)
 * both   — هر دو حالت added و owned
 * all    — همه رکوردهای شرکت
 * none   — بدون دسترسی
 */
export const PERMISSION_LEVEL = {
  ADDED: 'added',
  OWNED: 'owned',
  BOTH: 'both',
  ALL: 'all',
  NONE: 'none',
};

export const normalizePermissionLevel = (value) => {
  if (value == null || value === '') return PERMISSION_LEVEL.NONE;
  return String(value).trim().toLowerCase();
};

/** آیا سطح دسترسی غیر از none است */
export const isPermissionAllowed = (level) =>
  normalizePermissionLevel(level) !== PERMISSION_LEVEL.NONE;

/** ایجاد / افزودن (دکمه add، POST) */
export const canCreate = (level) => isPermissionAllowed(level);

/** ویرایش / حذف / تغییر وضعیت در سطح لیست */
export const canMutate = (level) => isPermissionAllowed(level);

/** manage_* — نمایش دکمه «افزودن» کنار فیلد (مثل agent، type) */
export const canManageField = (level) => isPermissionAllowed(level);

/**
 * دسترسی به یک رکورد خاص در UI (ویرایش/حذف سطر)
 * بک‌اند فیلتر view را اعمال می‌کند؛ این تابع فقط برای نمایش دکمه‌هاست.
 */
export const canAccessRecordByLevel = (
  level,
  { userId, ownerId = null, addedById = null } = {},
) => {
  const l = normalizePermissionLevel(level);
  const uid = userId != null ? Number(userId) : null;

  if (l === PERMISSION_LEVEL.ALL) return true;
  if (l === PERMISSION_LEVEL.NONE || !uid) return false;
  if (l === PERMISSION_LEVEL.ADDED) {
    return addedById != null && Number(addedById) === uid;
  }
  if (l === PERMISSION_LEVEL.OWNED) {
    return ownerId != null && Number(ownerId) === uid;
  }
  if (l === PERMISSION_LEVEL.BOTH) {
    return (
      (addedById != null && Number(addedById) === uid) ||
      (ownerId != null && Number(ownerId) === uid)
    );
  }
  return false;
};

/** استخراج permissions از پاسخ API و برگرداندن بدنه بدون آن */
export const splitApiPermissions = (payload) => {
  if (!payload || typeof payload !== 'object' || !('permissions' in payload)) {
    return { body: payload, permissions: null };
  }
  const { permissions, ...body } = payload;
  return { body, permissions: permissions && typeof permissions === 'object' ? permissions : null };
};

/** نرمال‌سازی آبجکت permissions */
export const normalizeApiPermissions = (permissions) => {
  if (!permissions || typeof permissions !== 'object') return {};
  const out = {};
  Object.keys(permissions).forEach((key) => {
    out[key] = normalizePermissionLevel(permissions[key]);
  });
  return out;
};
